import { render, staticRenderFns } from "./CreateObjectPopUp.vue?vue&type=template&id=f4c2d90e&scoped=true"
import script from "./CreateObjectPopUp.vue?vue&type=script&lang=js"
export * from "./CreateObjectPopUp.vue?vue&type=script&lang=js"
import style0 from "./CreateObjectPopUp.vue?vue&type=style&index=0&id=f4c2d90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c2d90e",
  null
  
)

export default component.exports